import React, { useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import './App.css';
import Navbar from './Components/Navbar';
import ProfileDetail from './Components/ProfileDetail';
import Resume from './Components/Resume';
import Projects from './Components/Projects';
import Contact from './Components/Contact';
import Footer from './Components/Footer';

function App() {

  const [activeSection, setActiveSection] = useState("profile");
    // Common animation variants
  const pageVariants = {
    initial: { opacity: 0, y: 80 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 80 },
  };

  const pageTransition = {
    duration: 0.6,
    ease: "easeOut",
  };

  const ProfileDetailRef = useRef(null);
  const ResumeRef = useRef(null);
  const ProjectsRef = useRef(null);
  const ContactRef = useRef(null);


  /*  Pratap */

  // return (
  //   <div className="App">
  //     <div className='App-header'>
  //       <Navbar
  //         ProfileDetailRef = {() => ProfileDetailRef.current?.scrollIntoView({ behavior: "smooth" })}
  //         ResumeRef = {() => ResumeRef.current?.scrollIntoView({ behavior: "smooth" })}
  //         ProjectsRef = {() => ProjectsRef.current?.scrollIntoView({ behavior: "smooth" })}
  //         ContactRef = {() => ContactRef.current?.scrollIntoView({ behavior: "smooth" })}
  //       />
  //       <div  style={{ width: "100%" }} ref={ProfileDetailRef}><ProfileDetail 
  //       scrollToProjects =  {() => ProjectsRef.current?.scrollIntoView({ behavior: "smooth" })}
  //       scrollToContact = {() => ContactRef.current?.scrollIntoView({ behavior: "smooth" })} /></div>
  //       <div  style={{ width: "100%" }} ref={ResumeRef}><Resume /></div>
  //       <div  style={{ width: "100%" }} ref={ProjectsRef}><Projects /></div>
  //       <div  style={{ width: "100%" }} ref={ContactRef}><Contact /></div>
  //       <Footer />
  //     </div>
  //   </div>
  // );

  /*   Vinay   */
   
  return (
    <div className="App">
      <div className="App-header">
        <Navbar
          ProfileDetailRef={() => setActiveSection("profile")}
          ResumeRef={() => setActiveSection("resume")}
          ProjectsRef={() => setActiveSection("projects")}
          ContactRef={() => setActiveSection("contact")}
        />

        {/* Animated section rendering */}
        <AnimatePresence mode="wait">
          {activeSection === "profile" && (
            <motion.div
              key="profile"
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={pageTransition}
            >
              <ProfileDetail
                scrollToProjects={() => setActiveSection("projects")}
                scrollToContact={() => setActiveSection("contact")}
              />
            </motion.div>
          )}

          {activeSection === "resume" && (
            <motion.div
              key="resume"
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={pageTransition}
            >
              <Resume />
            </motion.div>
          )}

          {activeSection === "projects" && (
            <motion.div
              key="projects"
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={pageTransition}
            >
              <Projects />
            </motion.div>
          )}

          {activeSection === "contact" && (
            <motion.div
              key="contact"
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={pageTransition}
            >
              <Contact />
            </motion.div>
          )}
        </AnimatePresence>

        <hr className="divider" />
        <Footer />
      </div>
    </div>
  );
}

export default App;
